// @flow

import styled from 'styled-components'

export const ErrorContainer = styled.div`
  position: relative;
  z-index: 1;
`
